import { create } from 'zustand';

const TOKEN_KEY = 'sa_token';
const USER_KEY = 'sa_user';

function loadToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || null;
  } catch {
    return null;
  }
}

function loadUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export const useAuthStore = create((set) => ({
  token: loadToken(),
  user: loadUser(),
  isAuthenticated: !!loadToken(),

  login: (token, user) => {
    try {
      localStorage.setItem(TOKEN_KEY, token);
      if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
    } catch {
      /* ignore */
    }
    set({ token, user: user || null, isAuthenticated: true });
  },

  setUser: (user) => {
    try {
      localStorage.setItem(USER_KEY, JSON.stringify(user));
    } catch {
      /* ignore */
    }
    set({ user });
  },

  setToken: (token) => {
    try {
      if (token) localStorage.setItem(TOKEN_KEY, token);
    } catch {
      /* ignore */
    }
    set({ token, isAuthenticated: !!token });
  },

  logout: () => {
    try {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
    } catch {
      /* ignore */
    }
    set({ token: null, user: null, isAuthenticated: false });
  },
}));

// Non-hook accessor for interceptors
export function getAuthToken() {
  return useAuthStore.getState().token;
}

export function forceLogout() {
  useAuthStore.getState().logout();
}

export default useAuthStore;
